import { unstable_generateUtilityClass as generateUtilityClass, unstable_generateUtilityClasses as generateUtilityClasses } from '@mui/utils';
export function getDateTimeRangePickerToolbarUtilityClass(slot) {
  return generateUtilityClass('MuiDateTimeRangePickerToolbar', slot);
}
export const dateTimeRangePickerToolbarClasses = generateUtilityClasses('MuiDateTimeRangePickerToolbar', ['root', 'startToolbar', 'endToolbar']);